const swiperReviews = new Swiper(".swiper-reviews", {
  // Optional parameters
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 20,

  breakpoints: {
    768: {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 20,
    },
  },

  autoplay: {
    delay: 5000,
  },

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-next",
    prevEl: ".swiper-prev",
  },
});
